<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="maintain.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="1100px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="maintain"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div class="vm-separate">
          <el-form-item label="关联售后单号">
            <el-input v-model="maintain.csNo" placeholder="请输入" @change="getReplacement(maintain.csNo)"/>
          </el-form-item>
          <el-form-item label="已过维保期">
            <el-radio-group v-model="maintain.isMaintenancePeriod">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="maintain.customerName" readonly placeholder="请输入">
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectCustomer.open()">
                选择
              </el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
          </el-form-item>
          <el-form-item label="出厂编号">
            <el-input v-model="maintain.factoryNo" placeholder="请输入"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="销售员">
            <el-input v-model="maintain.salesName" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="下单人">
            <el-input v-model="maintain.creatorName" placeholder="请输入"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="项目名称">
            <el-input v-model="maintain.projectName" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="电梯名称">
            <el-input v-model="maintain.elevatorNo" placeholder="请输入"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="退回单号">
            <el-input v-model="maintain.backNo" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="退回日期">
            <el-date-picker
                v-model="maintain.backTime"
                align="right"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="收货人">
            <el-input v-model="maintain.consignee" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="收货联系方式">
            <el-input v-model="maintain.consigneeContacts" placeholder="请输入"/>
          </el-form-item>
        </div>
        <el-form-item label="收货联系地址">
          <el-input v-model="maintain.deliveryAddress" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <div class="vm-separate">
          <el-form-item label="请求发货方式">
            <el-select v-model="maintain.deliveryMethod" filterable placeholder="请选择">
              <el-option
                  v-for="item in constants.deliveryType.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="请求发货日期">
            <el-date-picker
                v-model="maintain.deliveryTime"
                align="right"
                type="date"
                style="width: 100%"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"/>
          </el-form-item>
        </div>
        <el-form-item label="运费是否到付">
          <el-radio-group v-model="maintain.isFreightCollect">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="maintain.note" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <div style="padding: 0 0 10px 10px;width: 90%;margin: 0 auto">
          <div slot="toolbar">
            <el-button type="primary" style="margin-bottom: 10px" @click="getDetails1">
              新建
            </el-button>
          </div>
          <el-table
              :data="maintain.details"
              border>
            <el-table-column prop="materialNo" width="160" align="center" label="物料编号">
              <template slot-scope="scope">
                <el-input v-model="scope.row.materialNo" placeholder="请输入">
                  <el-button slot="append" icon="el-icon-search" @click="openMaterialSelectDialog(scope.$index)"/>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column prop="materialName" width="200" align="center" label="物料名称">
              <template slot-scope="scope">
                <el-input v-model="scope.row.materialName" placeholder="请输入" autosize type="textarea"/>
              </template>
            </el-table-column>
            <el-table-column prop="materialType" width="150" align="center" label="产品分类">
              <template slot-scope="scope">
                <el-select v-model="scope.row.materialType" clearable size="mini" placeholder="请选择">
                  <el-option
                      v-for="item in constants.materialType.$options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="originalProgramNo" width="130" align="center" label="原程序号">
              <template slot-scope="scope">
                <el-input v-model="scope.row.originalProgramNo" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="newProgramNo" width="130" align="center" label="新程序号">
              <template slot-scope="scope">
                <el-input v-model="scope.row.newProgramNo" type="textarea" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="serialNumber" width="130" align="center" label="变频器序列号">
              <template slot-scope="scope">
                <el-input v-model="scope.row.serialNumber" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="quantity" width="100" align="center" label="数量">
              <template slot-scope="scope">
                <el-input v-model="scope.row.quantity" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="unit" width="100" align="center" label="单位">
              <template slot-scope="scope">
                <el-input v-model="scope.row.unit" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="siteDesc" width="130" align="center" label="现场问题描述">
              <template slot-scope="scope">
                <el-input v-model="scope.row.siteDesc" type="textarea" placeholder="请输入"/>
              </template>
            </el-table-column>
            <el-table-column prop="deliveryType" width="130" align="center" label="发运类型">
              <template slot-scope="scope">
                <el-select v-model.trim="scope.row.deliveryType" clearable placeholder="请选择部门" style="width: 150px">
                  <el-option label="自制品/严施丹" value="自制品"/>
                  <el-option label="自制品/李岚" value="自制品"/>
                  <el-option label="电气产品/陈孝" value="电气产品"/>
                  <el-option label="电机板卡/陆彩霞" value="电机板卡"/>
                  <el-option label="电机整机/陆彩霞" value="电机整机"/>
                  <el-option label="外购件/张成娟" value="外购件"/>
                  <el-option label="维修件/徐陆宇" value="维修件"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
                label="操作"
                align="center"
                class-name="vm-table_operate"
                width="100px">
              <template slot-scope="scope">
                <el-button type="danger" @click="oneDelete(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <material-c-s-select ref="selectMaterial" @select="getDetails"/>
          <delivery-type-select ref="deliverySelect" @select="deliverySelect"/>
        </div>
        <div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            维修附件
          </div>
          <div>
            <el-upload
                action=""
                multiple
                :http-request="submitUpload"
                :show-file-list="false"
                :disabled="uploadLoading"
                style="display: inline-block; float: left; margin: 5px;">
              <el-button type="primary" plain>
                <i class="el-icon-upload el-icon--right"/>
                附件上传
              </el-button>
            </el-upload>
          </div>
          <el-table
              v-if="maintain.attachments"
              ref="payData1"
              :data="maintain.attachments">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="fileName" align="center" label="图片">
              <template slot-scope="scope">
                <el-image
                    style="width: 50px; height: 50px;margin-right: 10px"
                    :src="scope.row.imgUrl"
                    :preview-src-list="imgUrls"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件描述">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.fileName"
                    class="tabInput"
                    style="width: 400px;margin: 0 auto;text-align: center"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
              <template slot-scope="scope">
                <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import MaterialCSSelect from "@/views/afterSalesManagement/Replacement/MaterialCSSelect";
  import DeliveryTypeSelect from "@/views/afterSalesManagement/Replacement/DeliveryTypeSelect";
  import constant from "@/util/constant";
  import constants from "@/util/constants.js";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "MaintainEdit",
    components: {DeliveryTypeSelect, MaterialCSSelect, CustomerSelect},
    data() {
      return {
        constant,
        constants,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        maintainList: [],
        afterList: [],
        imgUrls: [],
        maintain: {
          pkid: "",
          billNo: "",
          creatorName: loginUtil.getName(),
          csNo: "",
          factoryNo: "",
          customerName: "",
          customerId: "",
          isMaintenancePeriod: false,
          siteName: "",
          siteContacts: "",
          backNo: "",
          backTime: "",
          salesName: "",
          consignee: "",
          consigneeContacts: "",
          deliveryAddress: "",
          deliveryMethod: "",
          deliveryTime: "",
          isFreightCollect: "",
          details: [],
          attachments: [],
          note: "",
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        console.log(row);
        this.maintain.pkid = row.pkid;
        this.dialogVisible = true;
        if (this.maintain.pkid > 0) {
          this.getData();
        } else {
          this.getNo();
        }
      },
      getData() {
        this.$http
          .get("basic", `maintains/${this.maintain.pkid}`)
          .then(resp => {
            this.maintain = resp;
            this.maintain.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "https://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
          });
      },
      getReplacement(billNo) {
        let params = {
          billNo: billNo,
        };
        if (billNo) {
          this.$http
            .get("basic", "replacementBills/getReplacementBillByNo", params)
            .then(resp => {
              this.maintain.customerId = resp.customerId;
              this.maintain.customerName = resp.customerName;
              this.maintain.customerBillNo = resp.customerBillNo;
              this.maintain.factoryNo = resp.salesOrderNo;
              this.maintain.projectName = resp.siteName;
              this.maintain.elevatorNo = resp.elevatorNo;
              this.maintain.siteContacts = resp.mobile;
              this.maintain.consignee = resp.consignee;
              this.maintain.consigneeContacts = resp.consigneeMobile;
              this.maintain.deliveryAddress = resp.deliveryAddress;
              this.maintain.salesName = resp.salesMan;
              this.maintain.salesName = resp.salesMan;
              console.log(resp);
            });
        }

      },
      oneDelete(index) {
        this.maintain.details.splice(index, 1);
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.maintain.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.maintain.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "https://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },

      fileDelete(row, index) {
        console.log(row);
        this.maintain.attachments.splice(index, 1);
      },

      getNo() {
        this.$http
          .get("basic", "maintains/getBillNo")
          .then(resp => {
            this.maintain.billNo = resp;
          });
      },
      openMaterialSelectDialog(index) {
        this.$refs.selectMaterial.open(index);
      },
      getDetails(row, index) {
        this.maintain.details[index].materialId = row.id;
        this.maintain.details[index].materialName = row.name;
        this.maintain.details[index].materialNo = row.no;
      },
      deliverySelect(row) {
        this.maintain.details[row.groupIndex].deliveryType = row.deliveryTypeName;
        this.maintain.details[row.groupIndex].deliveryPerson = row.userName;
        this.maintain.details[row.groupIndex].deliveryAccount = row.account;
      },
      getDetails1() {
        this.maintain.details.push({
          pkid: 0,
          masterId: 0,
          materialId: -1,
          materialName: "",
          materialNo: "",
          deliveryPerson: "",
          deliveryType: "",
          deliveryAccount: "",
          quantity: 1,
          unit: "",
        });
      },
      selectCustomer(row) {
        this.maintain.customerName = row.customerName;
        this.maintain.customerId = row.customerID;
      },

      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            if (this.maintain.pkid > 0) {
              this.$http
                .put("basic", "maintains", this.maintain)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "maintains", this.maintain)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
